import type { CountdownTime } from '@/hooks/useInProgressBooking';
import { TransText } from '@/i18n/trans/text';
import { Button, Icons, Typography } from '@packages/webshop-design-system';
import type React from 'react';

interface BookingExpiryContentProps {
  countdown: CountdownTime | null;
  onCheckoutClick: () => void;
  showCloseButton?: boolean;
  onClose?: () => void;
}

function BookingExpiryContent({
  countdown,
  onCheckoutClick,
  showCloseButton = false,
  onClose,
}: BookingExpiryContentProps): React.ReactElement {
  return (
    <div className="flex gap-3">
      <div className="flex-shrink-0 self-start text-info-text">
        <Icons.alertCircle />
      </div>

      <div className="flex flex-col gap-3">
        <div className="flex flex-wrap gap-1 text-dark">
          <Typography variant="paragraph">
            <TransText i18nKey="bookingSessionExpiresIn" />:
          </Typography>
          <span className="flex items-center gap-1">
            <Typography variant="paragraph">
              <TransText
                i18nKey="minutesCount"
                values={{ count: countdown?.minutes ?? 0 }}
              />
            </Typography>
            <Typography variant="paragraph">
              <TransText
                i18nKey="secondsCount"
                values={{ count: countdown?.seconds ?? 0 }}
              />
            </Typography>
          </span>
        </div>

        <Button
          variant="ghost"
          className="flex items-center gap-2 text-info-text hover:text-tint"
          onClick={onCheckoutClick}
          data-testid="continue-to-checkout-button"
        >
          <TransText i18nKey="continueToCheckout" />
          <Icons.chevronRight />
        </Button>
      </div>

      {showCloseButton && onClose && (
        <Button
          variant="ghostLink"
          className="ml-auto flex-shrink-0 items-start self-start"
          onClick={onClose}
          data-testid="booking-expiry-close-button"
        >
          <Icons.x width={24} height={24} />
        </Button>
      )}
    </div>
  );
}

export default BookingExpiryContent;
